// export default function HospURL(cellData) {
//   if (cellData.data.hospUrl) {
//     return (
//       <div>
//         <a href={cellData.data.hospUrl} target="_blank">
//           {cellData.data.NAME}
//         </a>
//       </div>
//     );
//   } else {
//     return <div>{cellData.data.NAME}</div>;
//   }
// }
import { Button } from "devextreme-react";

export default function HospURL(cellData) {
  const onClick = () => {
    window.open(cellData.data.hospUrl);
  };
  return (
    // <div>
    //   <a href={cellData.data.hospUrl} target="_blank">
    //     {cellData.data.LAB_NAME}
    //   </a>
    // </div>
    <div>
      {!cellData.data.LAB_NAME && (
        <Button
          icon="home"
          onClick={onClick}
          disabled={cellData.data.hospUrl ? false : true}
        />
      )}
    </div>
  );
}
